module.exports = __webpack_public_path__ + "static/media/user_care.660c3b3c.svg";